import React from 'react';

export default () => {
    return(
        <div>
            <h1 className="display-4">About Contact Manager</h1>
            <p className="lead">Simple app to manage contact</p>
            <p className="text-secondary">Version 1.0.0 via TechSavvyNG</p>
        </div>
    )
}